The underlying library question choice that the question choice is based on.

The availability of this field is dependent on the parent `DraftApplicationQuestion.sourceCode`:

- `Custom` is always null.
- `Library` is always non-null.
